import api from "@/api";



//查询图片
export const identifierIcon = () => {

    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/icons`,)
}

//查询列表
export const siteidentifiergetPage = (data) => {

    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/getPage`,data)
}

//修改
export const identifierIconUpdate = (data) => {

    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/update`,data)
}

//新增
export const identifierIconAdd = (data) => {

    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/insert`,data)
}


//删除
export const identifierIconDelete = (data) => {

    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/delete?id=${data.id}`,data)
}


//设备列表
export const homeDeviceAllPage = () => {

    return api.axss("post", `/ocm-oil-site/home/homeDevice/all/page`,)
}


//设备列表
export const oliSiteIdefierUntis = () => {

    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/units`,)
}


//设备列表
export const oliSiteIdefierColos = () => {

    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/colors`,)
}
